import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Api\Products\ProductShippingOptionsController::__invoke
* @see Http/Controllers/Api/Products/ProductShippingOptionsController.php:17
* @route '/api/products/shipping-options/{configurableProduct}/{productSku}'
*/
const ProductShippingOptionsController = (args: { configurableProduct: string | number | { group_identifier: string | number }, productSku: string | number } | [configurableProduct: string | number | { group_identifier: string | number }, productSku: string | number ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: ProductShippingOptionsController.url(args, options),
    method: 'get',
})

ProductShippingOptionsController.definition = {
    methods: ["get","head"],
    url: '/api/products/shipping-options/{configurableProduct}/{productSku}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Api\Products\ProductShippingOptionsController::__invoke
* @see Http/Controllers/Api/Products/ProductShippingOptionsController.php:17
* @route '/api/products/shipping-options/{configurableProduct}/{productSku}'
*/
ProductShippingOptionsController.url = (args: { configurableProduct: string | number | { group_identifier: string | number }, productSku: string | number } | [configurableProduct: string | number | { group_identifier: string | number }, productSku: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            configurableProduct: args[0],
            productSku: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        configurableProduct: typeof args.configurableProduct === 'object'
        ? args.configurableProduct.group_identifier
        : args.configurableProduct,
        productSku: args.productSku,
    }

    return ProductShippingOptionsController.definition.url
            .replace('{configurableProduct}', parsedArgs.configurableProduct.toString())
            .replace('{productSku}', parsedArgs.productSku.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Api\Products\ProductShippingOptionsController::__invoke
* @see Http/Controllers/Api/Products/ProductShippingOptionsController.php:17
* @route '/api/products/shipping-options/{configurableProduct}/{productSku}'
*/
ProductShippingOptionsController.get = (args: { configurableProduct: string | number | { group_identifier: string | number }, productSku: string | number } | [configurableProduct: string | number | { group_identifier: string | number }, productSku: string | number ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: ProductShippingOptionsController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Api\Products\ProductShippingOptionsController::__invoke
* @see Http/Controllers/Api/Products/ProductShippingOptionsController.php:17
* @route '/api/products/shipping-options/{configurableProduct}/{productSku}'
*/
ProductShippingOptionsController.head = (args: { configurableProduct: string | number | { group_identifier: string | number }, productSku: string | number } | [configurableProduct: string | number | { group_identifier: string | number }, productSku: string | number ], options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: ProductShippingOptionsController.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Api\Products\ProductShippingOptionsController::__invoke
* @see Http/Controllers/Api/Products/ProductShippingOptionsController.php:17
* @route '/api/products/shipping-options/{configurableProduct}/{productSku}'
*/
const ProductShippingOptionsControllerForm = (args: { configurableProduct: string | number | { group_identifier: string | number }, productSku: string | number } | [configurableProduct: string | number | { group_identifier: string | number }, productSku: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: ProductShippingOptionsController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Api\Products\ProductShippingOptionsController::__invoke
* @see Http/Controllers/Api/Products/ProductShippingOptionsController.php:17
* @route '/api/products/shipping-options/{configurableProduct}/{productSku}'
*/
ProductShippingOptionsControllerForm.get = (args: { configurableProduct: string | number | { group_identifier: string | number }, productSku: string | number } | [configurableProduct: string | number | { group_identifier: string | number }, productSku: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: ProductShippingOptionsController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Api\Products\ProductShippingOptionsController::__invoke
* @see Http/Controllers/Api/Products/ProductShippingOptionsController.php:17
* @route '/api/products/shipping-options/{configurableProduct}/{productSku}'
*/
ProductShippingOptionsControllerForm.head = (args: { configurableProduct: string | number | { group_identifier: string | number }, productSku: string | number } | [configurableProduct: string | number | { group_identifier: string | number }, productSku: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: ProductShippingOptionsController.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

ProductShippingOptionsController.form = ProductShippingOptionsControllerForm

export default ProductShippingOptionsController